/**
 * Create a slug compatible id for an object with the name and shortID
 *
 * @param {String} name The name of the object
 * @param {String} shortId The short ID for the object
 */
export function slugifyName(name: string, shortId?: string): string {
  const a = "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;";
  const b = "aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------";
  const p = new RegExp(a.split("").join("|"), "g");
  const slugName = (name || "")
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, "-and-") // Replace & with 'and'
    // eslint-disable-next-line no-useless-escape
    .replace(/[^\w\-]+/g, "") // Remove all non-word characters
    // eslint-disable-next-line no-useless-escape
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text

  return [slugName, shortId].filter(comp => comp && comp.length > 0).join("-");
}

/* eslint-disable no-useless-escape */
/**
 * Subdomains will be typed by the user, so we need to give them the option to type spaces & underscores.
 * End spaces can be trimmed with trimSubdomain on submit
 */
export function slugifySubdomain(name: string): string {
  const a = "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;";
  const b = "aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------";
  return name
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace("[^\\P{Punct}_]+", c => b.charAt(a.indexOf(c))) // Replace special characters besides underscore
    .replace(/&/g, "-and-") // Replace & with 'and'
    .replace(/[^\w\-]+/g, "") // Remove all non-word characters
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/\_\_+/g, "_") // Replace multiple underscore with single underscore
    .replace(/^-+/, "") // Trim - from start of text
    .toLowerCase();
}

export function trimSubdomain(name: string): string {
  return name.replace(/[-_]+$/, ""); // Remove trailing _ & -
}
